export type Testimonial = {
  name: string
  location: string
  text: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'María González',
    location: 'Miami, FL',
    text: 'Tengo todo organizado y eso me cambió la rutina. Antes perdía tiempo buscando mis herramientas entre citas.',
  },
  {
    name: 'Daniela Rivas',
    location: 'Houston, TX',
    text: 'La calidad se nota desde que lo abres. Los materiales se sienten sólidos, no como otros kits que he comprado.',
  },
  {
    name: 'Andrea Pineda',
    location: 'Orlando, FL',
    text: 'Lo llevo a las citas a domicilio sin problema. Cabe en mi bolsa y no tengo que cargar tres estuches distintos.',
  },
  {
    name: 'Karla Medina',
    location: 'Los Angeles, CA',
    text: 'Mis clientas comentan lo ordenado que se ve mi espacio. Es un detalle pequeño pero deja buena impresión.',
  },
  {
    name: 'Ashley Bennett',
    location: 'Charlotte, NC',
    text: 'I was not expecting much from a kit, honestly. But having a set place for everything really did make my days smoother.',
  },
  {
    name: 'Sofía Lozano',
    location: 'Dallas, TX',
    text: 'El diseño me gustó desde la foto, pero en persona se ve todavía mejor. Ya me han preguntado dónde lo compré.',
  },
  {
    name: 'Camila Torres',
    location: 'Las Vegas, NV',
    text: 'Cada herramienta tiene su compartimento, así que nada se mueve ni se maltrata cuando lo transporto.',
  },
  {
    name: 'Laura Castillo',
    location: 'Phoenix, AZ',
    text: 'Llevo poco más de un año en esto y me sirvió para armar bien mi setup. Funciona igual si apenas empiezas.',
  },
  {
    name: 'Natalia Fuentes',
    location: 'San Diego, CA',
    text: 'Compré uno para mí y después otro para mi asistente. Las dos lo usamos a diario sin quejas.',
  },
  {
    name: 'Jessica Miller',
    location: 'New York, NY',
    text: 'Compact, but it holds a full day of supplies. That was the main thing I needed and it delivers.',
  },
  {
    name: 'Paola Espinoza',
    location: 'Chicago, IL',
    text: 'Preparo mi estación mucho más rápido. No es magia, simplemente ya no busco nada.',
  },
  {
    name: 'Mariana Delgado',
    location: 'Miami, FL',
    text: 'Se ve elegante y cumple lo que promete. Justo lo que buscaba y no encontraba en otras marcas.',
  },
  {
    name: 'Emily Carter',
    location: 'Orlando, FL',
    text: 'My turnaround between appointments dropped noticeably. Small change, but it adds up over a full day.',
  },
  {
    name: 'Valentina Suárez',
    location: 'Houston, TX',
    text: 'Compré dos para el estudio. Mis técnicas los adoptaron sin que se los pidiera, eso dice bastante.',
  },
  {
    name: 'Gabriela Ramos',
    location: 'Dallas, TX',
    text: 'Antes cargaba varias bolsas. Ahora salgo con un solo kit y llego más tranquila a cada cita.',
  },
  {
    name: 'Rachel Thompson',
    location: 'Las Vegas, NV',
    text: 'It has traveled with me across a few states already and still looks new. Sturdier than I expected.',
  },
  {
    name: 'Isabella Moreno',
    location: 'Phoenix, AZ',
    text: 'Por el precio, la calidad me pareció justa. No es barato, pero tampoco se siente como un gasto perdido.',
  },
  {
    name: 'Olivia Brooks',
    location: 'Los Angeles, CA',
    text: 'Nothing gets lost or damaged now that everything has its own slot. Simple detail, big difference.',
  },
  {
    name: 'Adriana Vargas',
    location: 'New York, NY',
    text: 'Llegó rápido y bien empacado. Sin detalles ni piezas faltantes, que ya es mucho decir.',
  },
  {
    name: 'Lucía Herrera',
    location: 'San Diego, CA',
    text: 'Trabajo con más calma. Ya no ando buscando cosas frente a la clienta, y eso se siente más profesional.',
  },
]
